<template lang="html">
	<div class="ctn-duo-input row domain-selector-container">
		<div class="left inner-duo">
			<div class="ctn-input form-elem-container ctn-select ctn-label custom-selector" v-inputUI :class="{error: errors.has('domain_type')}">
				<label v-if="!domainType" for="select">Type de domaine</label>
				<v-select
					v-model="domainType"
					:options="domainTypes"
					v-validate="'required'"
					data-vv-value-path="mutableValue"
					data-vv-name="domain_type"
					:has-error="errors.has('domain_type')"
				/>
			</div>
			<div v-if="errors.has('domain_type')" class="error-message">{{ errors.first('domain_type') }}</div>
		</div>
		<div class="right inner-duo">
			<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('domain')}">
				<label for="domain">Nom de domaine</label>
				<input  type="text" name="domain" v-model="domain" @change="domainUpdated">
			</div>
			<div v-if="errors.has('domain')" class="error-message">{{ errors.first('domain') }}</div>
		</div>
		<div class="domain-selector-trash">
			<span class="icon-file-trash" @click="$emit('deleteDomain', index)"></span>
		</div>
	</div>
</template>

<script>

	import CustomSelect from './Form/CustomSelect';

	export default {
		name: 'DomainSelector',
		props: ['domainInfo', 'index', 'domainTypes'],
		components: { CustomSelect },
		data () {
			return {
				domainType: null,
				domain: this.domainInfo.host,
			}
		},
		beforeMount () {
			if (this.domainInfo) {
				this.domainType = this.domainInfo.type;
				this.domain = this.domainInfo.domain;
			}
		},
		methods: {
			domainUpdated () {
				this.$emit('domainUpdated',
					{
						index: this.index,
						domainInfo: { domain: this.domain, name: this.domainType.name }
					}
				)
			}
		},
		watch: {
			domainType (value) {
				this.domainUpdated();
			},
		},
	}
</script>

<style lang="scss">
	.domain-selector-trash {
		position: absolute;
		right: 5px;
		padding-top: 23px;
		cursor: pointer;
	}
	.domain-selector-container {
		display: flex;
		flex-flow: row;
		align-items: center !important;
	}
	.custom-selector {
		padding: 0.25rem 0;
		.selected-tag {
			position: absolute;
		}
	}
	.dropdown-toggle {
		border: none !important;
	}
</style>



// WEBPACK FOOTER //
// domain-selector.vue?79911bf4